const ReviewUtils = () => {
  // Hide all feedback bubbles on ESC
  window.addEventListener("keydown", triggerHideFeedbackContainers)
}

const triggerHideFeedbackContainers = e => {
  if (e.keyCode === 27) {
    window.dispatchEvent(new CustomEvent("hideFeedbackContainers"))
  }
}

export default ReviewUtils
